// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<div id='customer-deposit-accounts-check-deposit' class="box">
  <sub-header header="'Deposit multiple checks to account'"></sub-header>

    <!-- Product information -->
    <deposit-product-information account-details="\$ctrl.depositAccount">
    </deposit-product-information>

    <!-- Operation form -->
    <form name="\$ctrl.transactionForm">

      <check-form
          check-model="\$ctrl.checkFormModel"
          product-id="\$ctrl.productId"
          entry-type="'CREDIT'">
      </check-form>

      <div class="buttons">
        <button type="button"
                class="btn btn-success"
                ng-click="\$ctrl.addCheck()"
                ng-disabled="\$ctrl.transactionForm.\$invalid">
          Add
        </button>
      </div>
    </form>

    <div class="misc-transaction-listing__table" style="clear: both;">
      <table class="check-deposit-table table">
        <thead>
        <tr>
          <th>#</th>
          <th>MICR Number</th>
          <th>Valid from</th>
          <th>Issuing bank</th>
          <th>Amount</th>
          <th></th>
        </tr>
        </thead>
        <tbody ng-if="\$ctrl.userChecks.length > 0">
        <tr ng-repeat="check in \$ctrl.userChecks track by \$index">
          <td>{{ \$index + 1 }}.</td>
          <td>{{ check.micrNumber | micr }}</td>
          <td>{{ check.validFrom | nxDate }}</td>
          <td>{{ check.bankName }}</td>
          <td>
            <cash ng-disabled="true" ng-model="check.amount"></cash>
          </td>
          <td>
            <button type="button" class="btn btn-danger" ng-click="\$ctrl.removeCheck(\$index)">
              Remove
            </button>
          </td>
        </tr>
        <tr>
          <td colspan="3"></td>
          <td class="check-deposit-table__total-label">TOTAL</td>
          <td>
            <cash ng-disabled="true" ng-model="\$ctrl.totalAmount"></cash>
          </td>
          <td></td>
        </tr>
        </tbody>
      </table>
      <div  ng-if="\$ctrl.userChecks.length < 1" class="empty-message">
        <span>No checks have been added yet.</span>
      </div>
    </div>

    <div class="buttons">
      <button type="button"
              class="btn btn-warning"
              ng-click="\$ctrl.redirectBack()">
        Cancel
      </button>
      <button
          type="submit"
          class="misc-transaction__save btn btn-primary"
          ng-disabled="\$ctrl.userChecks.length < 1"
          ng-click="\$ctrl.deposit()">
        Deposit
      </button>
    </div>

</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/check-deposit/multiple-checks-deposit.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;